import { type AccessRoute, ROUTE_ACCESS } from '@nudool/shared';

function matchedStaticSegments(template: string, segments: string[]): number | null {
  const templateSegments = template.split('/');
  if (templateSegments.length > segments.length) return null;
  let staticCount = 0;
  for (const [index, part] of templateSegments.entries()) {
    if (part.startsWith('$')) {
      if (segments[index] === '') return null;
    } else if (part === segments[index]) {
      staticCount += 1;
    } else {
      return null;
    }
  }
  return staticCount;
}

/** The deepest map entry a real pathname falls under; a static segment beats a `$param` one. */
export function matchAccessRoute(pathname: string): AccessRoute | null {
  const segments = pathname.replace(/\/$/, '').split('/');
  let best: { route: AccessRoute; depth: number; staticCount: number } | null = null;
  for (const route of Object.keys(ROUTE_ACCESS) as AccessRoute[]) {
    const staticCount = matchedStaticSegments(route, segments);
    if (staticCount === null) continue;
    const depth = route.split('/').length;
    if (!best || depth > best.depth || (depth === best.depth && staticCount > best.staticCount)) {
      best = { route, depth, staticCount };
    }
  }
  return best?.route ?? null;
}
